import { render, staticRenderFns } from "./AdminParent.vue?vue&type=template&id=e2d128be&"
import script from "./AdminParent.vue?vue&type=script&lang=js&"
export * from "./AdminParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\ageo\\Documents\\Work\\fhapplication\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2d128be')) {
      api.createRecord('e2d128be', component.options)
    } else {
      api.reload('e2d128be', component.options)
    }
    module.hot.accept("./AdminParent.vue?vue&type=template&id=e2d128be&", function () {
      api.rerender('e2d128be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/dashboard/components/AdminParent.vue"
export default component.exports